import React, { useState } from 'react';
import {
    validateServiceInfo,
    validateServiceIdentificationInfo,
  } from '../../utils/validation';
import { initialServiceFormData } from './../../utils/formData';

function ServiceForm() {
    const [currentStep, setCurrentStep] = useState(1);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(initialServiceFormData);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value,
        });
    };

    const validateFields = () => {
        let newErrors = {};

        if (currentStep === 1) {
        newErrors = validateServiceInfo(formData);
        }

        if (currentStep === 2) {
        newErrors = validateServiceIdentificationInfo(formData);
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleNext = () => {
        if (validateFields()) {
        setCurrentStep(currentStep + 1);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFields()) {
        alert('Formulaire envoyé avec succès');
        }
    };

        
    const handleBack = () => {
        setCurrentStep(currentStep - 1);
    };
        

  return (
    <div className="inscription-container">
      <form onSubmit={handleSubmit} className='inscription-form'>
        {currentStep === 1 && (
          <div className="form-step">
            <h2 className='inscription-title'>Ajouter un service</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom de l’institution</label>
                    <input type="text" name="nomInstitution" value={formData.nomInstitution} onChange={handleChange} placeholder="Entrez le Nom de l’institution" />
                    {errors.nomInstitution && <p className="error">{errors.nomInstitution}</p>}
                </div>
                <div className="form-group">
                    <label>Adresse de l’institution</label>
                    <input type="text" name="adresseInstitution" value={formData.adresseInstitution} onChange={handleChange} placeholder="Entrez l'adresse de l’institution'" />
                    {errors.adresseInstitution && <p className="error">{errors.adresseInstitution}</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name='email' value={formData.email} onChange={handleChange} placeholder="Entrez l'email"  required />
                    {errors.email && <p className="error">{errors.email}</p>}
                </div>
                <div className="form-group">
                    <label>Numéro de téléphone de l'institut</label>
                    <input type="tel" name="telephone" value={formData.telephone} onChange={handleChange} placeholder="+223 ..." />
                    {errors.telephone && <p className="error">{errors.telephone}</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Catégorie</label>
                    <select name="typeInstitution" value={formData.typeInstitution} onChange={handleChange}>
                        <option value="Hôpital">Hôpital</option>
                        <option value="Clinique">Clinique</option>
                        <option value="Entreprise">Entreprise</option>
                    </select>
                    {errors.typeInstitution && <p className="error">{errors.typeInstitution}</p>}
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="info-supplementaire">Info supplémentaire</label>
                <textarea id="info-supplementaire" placeholder="Les autres Informations"></textarea>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="form-step">
            <h2 className='inscription-title'>Informations d'identification</h2>
            <div className="form-row">
                <div className="form-group">
                <label>Nom d'utilisateur</label>
                <input type="text" name="username"
              value={formData.username}
              onChange={handleChange} placeholder="Entrez le nom d'utilisateur" />
              {errors.username && <p className="error">{errors.username}</p>}
                </div>
                <div className="form-group">
                <label>Mot de passe</label>
                <input type="password" name="password"
              value={formData.password}
              onChange={handleChange} placeholder="Entrez le mot de passe" />
              {errors.password && <p className="error">{errors.password}</p>}
     
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                <label>Nom du contact principal</label>
                <input type="text" name="nomContact"
              value={formData.nomContact}
              onChange={handleChange} placeholder="Entrez le Nom du contact principal" />
              {errors.nomContact && <p className="error">{errors.nomContact}</p>}
                </div>
                <div className="form-group">
                <label>Poste au sein de l'institution</label>
                <input type="text" name="posteContact"
              value={formData.posteContact}
              onChange={handleChange} placeholder="Entrez le mot de passe" />
              {errors.posteContact && <p className="error">{errors.posteContact}</p>}
                </div>
            </div>
          </div>
        )}

        <div className="form-navigation">
        {currentStep > 1 && (
            <button type="button" onClick={handleBack} className="back-button">
            Retour
            </button>
        )}
        {currentStep < 2 ? (
            <button type="button" onClick={handleNext} className="next-button">
            Suivant
            </button>
        ) : (
            <button type="submit" className="submit-button">
            Enregistrer
            </button>
        )}
        </div>
      </form>
    </div>
  )
}

export default ServiceForm